import PiniaPersistedState from 'pinia-plugin-persistedstate'
import { useAppStore } from '@/stores/app.js'
import { useUIStore } from '@/stores/ui.js'
import Vue3Toastify from 'vue3-toastify'
import 'vue3-toastify/dist/index.css'
import { createPinia } from 'pinia'
import { createApp } from 'vue'
import Router from './router'
import AppI18n from '@/i18n.js'
import App from './App.vue'

const $app = createApp(App)
  .use(Router)
  .use(Vue3Toastify, {
    autoClose: 5000,
    clearOnUrlChange: false
  })
  .use(AppI18n)
  .use(createPinia().use(PiniaPersistedState))

await useAppStore().init()
useAppStore().applyUiScale()

// Theme vor dem Mount anwenden: aus prefers-color-scheme initialisieren bzw.
// persistierte Nutzerwahl übernehmen, damit die .dark-Klasse früh steht.
useUIStore().initTheme()

$app.mount('#app')
